import { AppBar, Avatar, Chip, Divider, Drawer, IconButton, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import React from 'react';

import GuiaSolicitacao from './GuiaSolicitacao';

const styles = theme => ({
  drawerTitle: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  guiaSolicitacaoStyle: {
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(5),
  },
  dividerTopStyle: {
    marginTop: theme.spacing(10),
    backgroundColor: '#f50057',
  },
  dividerStyle: {
    backgroundColor: '#f50057',
  },
  avatar: {
    marginLeft: '20px',
    fontSize: 12,
    marginRight: '670px',
  },
  chip: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(1) * -2,
  }
});

class DrawerGuiaSolicitacao extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { classes, open, handleClose, guiasSolicitacao } = this.props;

    return (
      <Drawer
        anchor='left'
        open={open}
        onClose={handleClose}
        variant='permanent'
      >
        <div tabIndex={0} role='button' >
          <AppBar position='sticky' color='default' elevation={0}>
            <div className={classes.drawerTitle}>
              <Typography>Qtde. de Guias</Typography>
              <Avatar className={classes.avatar}>{guiasSolicitacao.length}</Avatar>
              <IconButton
                key='close'
                aria-label='Close'
                color='inherit'
                title='Fechar'
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </AppBar>
          {guiasSolicitacao.map((guiaSolic, idx) =>
            <div className={classes.guiaSolicitacaoStyle} key={idx}>
              {idx !== 0
              ? <div>
                <Divider className={classes.dividerTopStyle} />
                <Divider className={classes.dividerStyle} />
                <div className={classes.chip}>
                  <Chip
                  color='secondary'
                  label={'Guia ' + guiaSolic.codGuia} />
                </div>
              </div>
              : null}
              <GuiaSolicitacao
                codGuia={guiaSolic.codGuia}
                guia={guiaSolic}
                readOnly={true}
                emAuditoria={true}
              />
            </div>)
          }
        </div>
      </Drawer>
    );
  }
}
export default withStyles(styles)(DrawerGuiaSolicitacao);
